// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/vue/js/" + chunkId + "." + {"70":"fbdf0a29","302":"f1de9a47","564":"71a8b3fe","645":"b242f5f6","897":"ff27d39e","971":"4b327d01","974":"d447428e"}[chunkId] + ".js";
};